import { PERMISSION as $P } from 'plugins/kapida/platformConfigs/integrationMaps/permissions';
import { objectSelector } from 'theme/utils';

class Permission {
  constructor({ pk, name, slug, namespacePath, isVisibleForStaff }) {
    this.pk = pk;
    this.name = name;
    this.slug = slug;
    this.namespacePath = namespacePath;
    this.isVisibleForStaff = isVisibleForStaff;
  }
}

export const permissionsMapper = (permissions = []) => {
  return permissions.map((item) => {
    return new Permission({
      pk: objectSelector(item, $P.PK),
      name: objectSelector(item, $P.NAME),
      slug: objectSelector(item, $P.SLUG),
      namespacePath: objectSelector(item, $P.NAMESPACE_PATH),
      isVisibleForStaff: objectSelector(item, $P.IS_VISIBLE_FOR_STAFF),
    });
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/permissions.js